import styled from "styled-components";
import { CreditCard } from './atoms';
import { Molecule } from 'AppReact';

const wrapperTemplate = styled.div``

export default Molecule({
  template: wrapperTemplate,
  type: 'formgroup',
  atoms: [
    {
      component: CreditCard,
      name: 'CreditCard',
      displayValue: ({ cardDetails }) => {

        const cardInfo = {
          number: cardDetails.cardNumber,
          name: cardDetails.fullName,
          expiry: cardDetails.expiration,
          cvc: cardDetails.cardCode,
        }

        const _onChange = ({ handle }, o) => handle(o)
        return {
          ...cardInfo,
          _onChange,
          onChangeField: 'onChange'
        }
      }
    },
  ]
}
)
